'use strict';exports.__esModule = true;exports.SETTINGS = exports.BOTTOM_LOGOS = exports.TOP_LOGOS = undefined;var _RealtorsLogos = require('../../../static/images/RealtorLanding/RealtorsLogos');var _RealtorsLogos2 = _interopRequireDefault(_RealtorsLogos);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var TOP_LOGOS = exports.TOP_LOGOS = [
_RealtorsLogos2.default.victory,
_RealtorsLogos2.default.theRightWay,
_RealtorsLogos2.default.stockbroker,
_RealtorsLogos2.default.samariaRealEstate,
_RealtorsLogos2.default.requires,
_RealtorsLogos2.default.replace,
_RealtorsLogos2.default.remax,
_RealtorsLogos2.default.reich,
_RealtorsLogos2.default.realeStateDolutions,
_RealtorsLogos2.default.realEstateWell,
_RealtorsLogos2.default.realEstateSolutions,
_RealtorsLogos2.default.quickRealEstate,
_RealtorsLogos2.default.provence,
_RealtorsLogos2.default.maxHome,
_RealtorsLogos2.default.homeland,
_RealtorsLogos2.default.homeInIsrael];

var BOTTOM_LOGOS = exports.BOTTOM_LOGOS = [
_RealtorsLogos2.default.hmInvest,
_RealtorsLogos2.default.govAri,
_RealtorsLogos2.default.goldmanRealEstate,
_RealtorsLogos2.default.goReality,
_RealtorsLogos2.default.friendshipFoundation,
_RealtorsLogos2.default.franzi,
_RealtorsLogos2.default.fiveRealEstateConsultants,
_RealtorsLogos2.default.firstRealEstate,
_RealtorsLogos2.default.eranDrori,
_RealtorsLogos2.default.elios,
_RealtorsLogos2.default.claireWilliams,
_RealtorsLogos2.default.apartmentsFirst,
_RealtorsLogos2.default.angloSaxon,
_RealtorsLogos2.default.group];


var SETTINGS = exports.SETTINGS = {
    loop: true,
    slidesPerView: 8,
    spaceBetween: 30,
    loopedSlides: TOP_LOGOS.length,
    loopFillGroupWithBlank: false,
    centeredSlides: false,
    breakpoints: {
        1656: {
            slidesPerView: 6 },

        1400: {
            slidesPerView: 5 },

        1200: {
            slidesPerView: 4 },

        804: {
            slidesPerView: 3 },

        460: {
            slidesPerView: 2 } } };


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingLogosCarousel/constants.js
// module id = 2688
// module chunks = 0